import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/aiplus-web/src/app/main/ui/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/aiplus-web/src/app/main/ui/footer.tsx");
;
import(/* webpackMode: "eager" */ "/data/aiplus-web/src/app/main/ui/main.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/aiplus-web/src/app/main/ui/top.tsx");
